module.exports = __webpack_public_path__ + "img/betrokken.df9b84ad18086904edfc5fe8401ddafd.svg";